"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2972],{

/***/ 62972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ autosuggest_card_header; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(59106);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61250);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.13.5_@types+react@17.0.62_react@17.0.2/node_modules/@mui/icons-material/Search.js
var Search = __webpack_require__(77797);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Avatar/Avatar.js + 1 modules
var Avatar = __webpack_require__(36762);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/CardHeader/CardHeader.js
var CardHeader = __webpack_require__(68368);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(74112);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(55537);
// EXTERNAL MODULE: ../../node_modules/.pnpm/tss-react@4.8.6_@emotion+react@11.11.1_@emotion+server@11.11.0_react@17.0.2/node_modules/tss-react/esm/mui.js
var mui = __webpack_require__(71601);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(93089);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(99758);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(48417);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.13.5_@types+react@17.0.62_react@17.0.2/node_modules/@mui/icons-material/Close.js
var Close = __webpack_require__(426);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Chip/Chip.js + 1 modules
var Chip = __webpack_require__(84074);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Grid/Grid.js + 1 modules
var Grid = __webpack_require__(27908);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/IconButton/IconButton.js
var IconButton = __webpack_require__(49692);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/MenuItem/MenuItem.js
var MenuItem = __webpack_require__(98242);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Paper/Paper.js
var Paper = __webpack_require__(51804);
// EXTERNAL MODULE: ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/lodash.js
var lodash = __webpack_require__(39378);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(29901);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/FormControl/FormControl.js
var FormControl = __webpack_require__(39829);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/FormHelperText/FormHelperText.js
var FormHelperText = __webpack_require__(1679);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/InputBase/InputBase.js
var InputBase = __webpack_require__(78511);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/InputLabel/InputLabel.js
var InputLabel = __webpack_require__(66909);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/colors/red.js
var red = __webpack_require__(88665);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@1.2.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(14517);
;// CONCATENATED MODULE: ./components/chip-filter/chip-input.tsx
/**
 * Notice: Some code was adapted from Material-UI's text field.
 *         Copyright (c) 2014 Call-Em-All (https://github.com/callemall/material-ui)
 */ 













var useStyle = (0,mui/* makeStyles */.ZL)()({
    root: {
        width: "100%"
    },
    input: {
        "@media print": {
            display: "none"
        }
    },
    label: {
        top: 4
    },
    labelShrink: {
        top: 0
    },
    helperText: {
        marginBottom: -20
    },
    error: {
        "&:after": {
            backgroundColor: red/* default.A400 */.Z.A400,
            transform: "scaleX(1)"
        }
    }
});
var defaultChipRenderer = function(param) {
    var text = param.text, isFocused = param.isFocused, isDisabled = param.isDisabled, handleClick = param.handleClick, handleDelete = param.handleDelete;
    return /*#__PURE__*/ _jsx(MUIChip, {
        style: {
            pointerEvents: isDisabled ? "none" : undefined,
            backgroundColor: isFocused ? "blue" : undefined
        },
        onClick: handleClick,
        onDelete: handleDelete,
        label: text
    });
};
var ChipInput = function(props) {
    var ref;
    var classes = useStyle().classes;
    var ref1 = (0,react.useState)(false), isFocused = ref1[0], setIsFocused = ref1[1];
    var ref2 = (0,react.useState)([]), chips = ref2[0], setChips = ref2[1];
    var ref3 = (0,react.useState)(null), focusedChip = ref3[0], setFocusedChip = ref3[1];
    var ref4 = (0,react.useState)(props.inputValue), inputValue = ref4[0], setInputValue = ref4[1];
    var ref5 = (0,react.useState)(props.clearInputValueOnChange), clearInputValueOnChange = ref5[0];
    // const [value] = useState(props.value);
    var actualInput = (0,react.useRef)(undefined);
    (0,react.useEffect)(function() {
        if (props.disabled) {
            setFocusedChip(null);
            return;
        }
        if (props.chips && clearInputValueOnChange) {
            if (inputValue) {
                var ref, ref1;
                (ref = props.InputProps) === null || ref === void 0 ? void 0 : (ref1 = ref.onChange) === null || ref1 === void 0 ? void 0 : ref1.call(ref, {
                    target: {
                        value: ""
                    }
                });
                setInputValue("");
            }
        }
    }, [
        props.chips
    ]);
    var focus = function() {
        var ref;
        (ref = actualInput.current) === null || ref === void 0 ? void 0 : ref.focus();
        if (focusedChip) {
            setFocusedChip(null);
        }
    };
    var handleInputBlur = function(event) {
        var ref, ref1;
        (ref = props.InputProps) === null || ref === void 0 ? void 0 : (ref1 = ref.onBlur) === null || ref1 === void 0 ? void 0 : ref1.call(ref, event);
        setIsFocused(false);
        if (focusedChip) {
            setFocusedChip(null);
        }
    };
    var handleInputFocus = function(event) {
        var ref, ref1;
        setIsFocused(true);
        (ref = props.InputProps) === null || ref === void 0 ? void 0 : (ref1 = ref.onFocus) === null || ref1 === void 0 ? void 0 : ref1.call(ref, event);
    };
    var handleKeyDown = function(event) {
        var ref;
        if ((ref = props.InputProps) === null || ref === void 0 ? void 0 : ref.onKeyDown) {
            // Needed for arrow controls on menu in autocomplete scenario
            props.InputProps.onKeyDown(event);
            // Check if the callback marked the event as isDefaultPrevented() and skip further actions
            // enter key for example should not always add the current value of the inputField
            if (event.isDefaultPrevented()) {
                return;
            }
        }
        var _chips;
        var relevantChips = (_chips = props.chips) !== null && _chips !== void 0 ? _chips : chips;
        if (event.key === "Backspace" || event.key === "Delete") {
            if (event.target.value !== "") {
                return;
            }
            if (focusedChip === null && event.key === "Backspace") {
                setFocusedChip(relevantChips.length - 1);
            } else if (focusedChip !== null) {
                var value = relevantChips[focusedChip];
                handleDeleteChip(value, focusedChip);
                if (event.keyCode === 8 && focusedChip > 0) {
                    setFocusedChip(focusedChip - 1);
                }
            }
        } else if (event.key === "ArrowLeft") {
            if (focusedChip === null && event.target.value === "" && relevantChips.length) {
                setFocusedChip(relevantChips.length - 1);
            } else if (focusedChip !== null && focusedChip > 0) {
                setFocusedChip(focusedChip - 1);
            }
        } else if (event.key === "ArrowRight") {
            if (focusedChip !== null && focusedChip < relevantChips.length - 1) {
                setFocusedChip(focusedChip + 1);
            } else {
                setFocusedChip(null);
            }
        } else {
            setFocusedChip(null);
        }
    };
    var handleUpdateInput = function(e) {
        var ref, ref1;
        if (!props.inputValue) {
            setInputValue(e.target.value);
        }
        (ref = props.InputProps) === null || ref === void 0 ? void 0 : (ref1 = ref.onChange) === null || ref1 === void 0 ? void 0 : ref1.call(ref, e);
    };
    var handleDeleteChip = function(chip, i) {
        if (props.chips) {
            if (typeof chip === "object") {
                var ref;
                (ref = props.onDelete) === null || ref === void 0 ? void 0 : ref.call(props, chip, i);
            }
        } else {
            chips.splice(i, 1); // remove the chip at index i
            if (focusedChip !== null) {
                if (focusedChip === i) {
                    setFocusedChip(null);
                } else if (focusedChip > i) {
                    setFocusedChip(focusedChip - 1);
                }
            }
            setChips((0,_to_consumable_array/* default */.Z)(chips));
        }
    };
    var setActualInputRef = function(ref) {
        actualInput.current = ref;
    };
    var _chips;
    var stateOrPropChips = (_chips = props.chips) !== null && _chips !== void 0 ? _chips : chips;
    var chipInputValue = ((ref = props.InputProps) === null || ref === void 0 ? void 0 : ref.onChange) ? props.inputValue : inputValue;
    var ref6;
    var hasInput = chips.length > 0 || ((ref6 = chipInputValue === null || chipInputValue === void 0 ? void 0 : chipInputValue.length) !== null && ref6 !== void 0 ? ref6 : 0) > 0;
    var shrinkFloatingLabel = props.label !== null && (hasInput || isFocused);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
        variant: "standard",
        fullWidth: props.fullWidth,
        className: (0,clsx_m["default"])(props.className, classes.root),
        error: !!props.error,
        required: props.required,
        onClick: focus,
        disabled: props.disabled,
        ref: props.ref,
        children: [
            props.label && /*#__PURE__*/ (0,jsx_runtime.jsx)(InputLabel/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                htmlFor: String(props.id),
                classes: {
                    root: classes.label,
                    shrink: classes.labelShrink
                },
                shrink: shrinkFloatingLabel,
                focused: isFocused
            }, props.InputLabelProps), {
                children: props.label
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                container: true,
                spacing: 1,
                marginTop: -0.5,
                children: [
                    stateOrPropChips.map(function(chip, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            children: props.renderChip({
                                chip: chip,
                                text: typeof chip === "object" && chip !== null && "text" in chip ? chip.text : "",
                                isDisabled: !!props.disabled,
                                isFocused: focusedChip === i,
                                handleClick: function() {
                                    return setFocusedChip(i);
                                },
                                handleDelete: function() {
                                    return handleDeleteChip(chip, i);
                                }
                            })
                        }, i);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputBase/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            multiline: true,
                            classes: {
                                input: classes.input
                            },
                            id: String(props.id),
                            value: chipInputValue,
                            inputRef: setActualInputRef,
                            disabled: props.disabled,
                            fullWidth: props.fullWidthInput,
                            placeholder: !hasInput && (shrinkFloatingLabel || !props.label) ? props.placeholder : undefined
                        }, props.InputProps), {
                            onKeyDown: handleKeyDown,
                            onFocus: handleInputFocus,
                            onBlur: handleInputBlur,
                            onChange: handleUpdateInput
                        }))
                    })
                ]
            }),
            props.helperText && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props.FormHelperTextProps), {
                className: props.FormHelperTextProps ? (0,clsx_m["default"])(props.FormHelperTextProps.className, classes.helperText) : classes.helperText,
                children: props.helperText
            }))
        ]
    });
};
/* harmony default export */ var chip_input = (ChipInput);

// EXTERNAL MODULE: ./hooks/use-translation.tsx
var use_translation = __webpack_require__(16237);
;// CONCATENATED MODULE: ./components/chip-filter/autosuggest-chip-input.tsx




var _selected, // Then we just need to select the values
_currentlySelected, _key, _currentlySelected1, _key1, // Then we just need to select the values
_currentlySelected2, _key2, _currentlySelected3, _key3;












var useStyles = (0,mui/* makeStyles */.ZL)()({
    suggestionsContainerOpen: {
        position: "absolute",
        maxHeight: 300,
        overflowY: "scroll",
        zIndex: 10
    },
    textField: {
        width: "100%"
    },
    discardGrid: {
        direction: "rtl"
    },
    discardButton: {
        padding: 8,
        "@media print": {
            display: "none"
        }
    }
});
var findHighlights = function(input, query) {
    if (input.length === 0) {
        return [];
    }
    var keywords = query.split(" ").filter(function(s) {
        return s.length;
    }).map(function(s) {
        return [
            s,
            new RegExp(s, "i")
        ];
    });
    if (keywords.length === 0) {
        return input.map(function(o) {
            return (0,_object_spread/* default */.Z)({
                highlight: [
                    {
                        isHighlighted: false,
                        text: o.name
                    }
                ]
            }, o);
        });
    }
    var filteredOptions = input.filter(function(param) {
        var name = param.name;
        return keywords.every(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), _ = _param[0], k = _param[1];
            return k.test(name);
        });
    });
    // Then for all the options we know match the input, we split them on all keywords they contain and mark the matching parts as highligted
    return filteredOptions.map(function(option) {
        var highlightedOption = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, option), {
            highlight: [
                {
                    isHighlighted: false,
                    text: option.name
                }
            ]
        });
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keywords[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _value = (0,_sliced_to_array/* default */.Z)(_step.value, 2), word = _value[0], regex = _value[1];
                var newHighlights = [];
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = highlightedOption.highlight[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var _value1 = _step1.value, isHighlighted = _value1.isHighlighted, text = _value1.text;
                        // This section is already split so we ignore it
                        if (isHighlighted) {
                            newHighlights.push({
                                isHighlighted: isHighlighted,
                                text: text
                            });
                            continue;
                        }
                        // If we're here this section is unsplit, so we try to split it with the current keyword
                        var sections = text.split(regex);
                        // If we only get one section back, this keyword was not in this substring, so we simply continue with another word
                        if (sections.length === 1) {
                            newHighlights.push({
                                isHighlighted: isHighlighted,
                                text: text
                            });
                            continue;
                        }
                        var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                        try {
                            // Since we split on the entire keyword, this means this word is present between every element of the section array
                            for(var _iterator2 = sections[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                var text1 = _step2.value;
                                newHighlights.push({
                                    isHighlighted: false,
                                    text: text1
                                });
                                newHighlights.push({
                                    isHighlighted: true,
                                    text: word
                                });
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                    _iterator2.return();
                                }
                            } finally{
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }
                        // We needed to add "section word section word section", but added one word too many in the loop, so we remove the last one
                        newHighlights.pop();
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                highlightedOption.highlight = newHighlights;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return highlightedOption;
    });
};
var AutosuggestChipInput = function(props) {
    var ref = useStyles(), classes = ref.classes, theme = ref.theme;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,use_translation/* useTranslation */.$)("shared"), 1), t = ref1[0];
    var ref2 = (0,react.useState)(false), isFocused = ref2[0], setIsFocused = ref2[1];
    var ref3 = (0,react.useState)([]), chips = ref3[0], setChips = ref3[1];
    var ref4 = (0,react.useState)(null), selectedSuggestion = ref4[0], setSelectedSuggestion = ref4[1];
    var ref5 = (0,react.useState)(""), textFieldInput = ref5[0], setTextFieldInput = ref5[1];
    // The "chain" of selections we've made, like in the Car type we might've selected ["doors", "right"] (not selected as strings tho)
    var ref6 = (0,react.useState)([]), selectionChain = ref6[0], setSelectionChain = ref6[1];
    var _initialSelection;
    var selectedOptions = (0,react.useRef)((_initialSelection = props.initialSelection) !== null && _initialSelection !== void 0 ? _initialSelection : {});
    // Other code might add filters, in that case we ensure those chips exist
    var initialSelection = (0,react.useRef)();
    (0,react.useEffect)(function() {
        if (!props.initialSelection) {
            return;
        }
        var chosen;
        if (initialSelection.current) {
            chosen = getNewOptions(initialSelection.current, props.initialSelection);
        } else {
            initialSelection.current = props.initialSelection;
            chosen = props.initialSelection;
        }
        var newChips = outerChipSelect(chosen, selectedOptions.current, props.suggestionBase, function() {
            return props.onSuggestions((0,_object_spread/* default */.Z)({}, selectedOptions.current));
        }, t);
        var combinedChips = (0,_to_consumable_array/* default */.Z)(chips);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var chip = _step.value;
                // If two chips have the same text value and highligted section, they must represent the same value
                if (chips.some(function(existing) {
                    return existing.name === chip.name && existing.highlighted === chip.highlighted;
                })) {
                    return "continue";
                }
                combinedChips.push(chip);
            };
            for(var _iterator = newChips[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        setChips(combinedChips);
    }, [
        props.initialSelection
    ]);
    // We store references to all the suggestion divs in the autosuggest box, so we can scroll to the current selected one if it exists the screen
    var suggestionRef = (0,react.useRef)([]);
    var currentSuggestion = (0,react.useRef)(undefined);
    // We take the content of the last suggestion in the chain, or if theres no chain, the root
    var suggestions = (0,react.useMemo)(function() {
        var last = selectionChain[selectionChain.length - 1];
        if (last) {
            if ("options" in last && last.options) {
                return last.options;
            }
            if ("values" in last && last.values) {
                return last.values;
            }
        }
        var _suggestionBase;
        return (_suggestionBase = props.suggestionBase) !== null && _suggestionBase !== void 0 ? _suggestionBase : [];
    }, [
        selectionChain,
        props.suggestionBase
    ]);
    var filteredSuggestions = (0,react.useMemo)(function() {
        var sections = textFieldInput.split(":");
        var ref;
        var query = ((ref = sections[sections.length - 1]) !== null && ref !== void 0 ? ref : "").trim();
        var typedSuggestions = suggestions;
        var highlights = findHighlights(typedSuggestions, query);
        if (highlights.length !== 0) {
            setSelectedSuggestion(0);
        }
        return highlights;
    }, [
        suggestions,
        textFieldInput
    ]);
    var renderChip = function(param) {
        var chip = param.chip, isFocused = param.isFocused, isDisabled = param.isDisabled, handleClick = param.handleClick, handleDelete = param.handleDelete;
        var _colors;
        var colors = (_colors = chip.colors) !== null && _colors !== void 0 ? _colors : {
            normal: undefined,
            selected: theme.palette.primary.main,
            hovered: undefined
        };
        // Some theme colors are just set to "blue" this is bad, so we replace that with primary
        if (colors.selected === "blue") {
            colors.selected = theme.palette.primary.main;
        }
        var _selected;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
            style: {
                pointerEvents: isDisabled ? "none" : undefined,
                backgroundColor: isFocused ? (_selected = colors.selected) !== null && _selected !== void 0 ? _selected : colors.normal : colors.normal,
                cursor: isFocused ? "text" : "pointer",
                // If we're selected and have no selected color, we lower opacity
                opacity: isFocused && colors.selected === undefined ? 0.6 : 1
            },
            onClick: handleClick,
            onDelete: handleDelete,
            label: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    chip.highlighted && /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                        children: [
                            chip.highlighted,
                            ": "
                        ]
                    }),
                    chip.name
                ]
            })
        });
    };
    var didSelectSuggestion = function(selectedSuggestion) {
        var selected = filteredSuggestions[selectedSuggestion];
        if (selected === undefined) {
            // Either the user wanted to search(if allowed) for a keyword, or they wanna go a level up
            if (selectionChain.length === 0 && props.supportsSearch) {
                var selected1 = selectedOptions.current;
                var _search;
                (_search = (_selected = selected1).search) !== null && _search !== void 0 ? _search : _selected.search = [];
                var _search1;
                selected1.search = (_search1 = selected1.search) !== null && _search1 !== void 0 ? _search1 : [];
                selected1.search.push(textFieldInput);
                var newChip = {
                    name: textFieldInput,
                    highlighted: t("shared:search", {
                        defaultValue: "Search"
                    }),
                    removeAssociatedFilter: function() {
                        var ref;
                        selected1.search = (ref = selected1.search) === null || ref === void 0 ? void 0 : ref.filter(function(k) {
                            return k !== textFieldInput;
                        });
                    }
                };
                setChips((0,_to_consumable_array/* default */.Z)(chips).concat([
                    newChip
                ]));
                setTextFieldInput("");
            } else if (selectionChain.length !== 0) {
                setSelectionChain(selectionChain.slice(0, -1));
            }
            props.onSuggestions((0,_object_spread/* default */.Z)({}, selectedOptions.current));
        } else if ("options" in selected || "values" in selected) {
            // Then we have new options to present
            var selectedTyped = selected;
            var newChain = (0,_to_consumable_array/* default */.Z)(selectionChain).concat([
                selectedTyped
            ]);
            setSelectionChain(newChain);
            setTextFieldInput(newChain.map(function(s) {
                return s.name;
            }).join(": ") + ": ");
        } else if ("value" in selected) {
            // An option has been selected, so we add it to the filter using the chain of categories, after that we can construct a new chip with highligts from the chain, and a function to remove the filter again
            // We then go through the chain and set the value we just selected on the filter
            var target = selectedOptions.current;
            // The last part of the chain selects the array of values, where every other selects other objects with filters on
            var last = selectionChain[selectionChain.length - 1];
            var previous = selectionChain.slice(0, selectionChain.length - 1);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = previous[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var key = _step.value.key;
                    var newTarget = target[key];
                    if (!newTarget) {
                        newTarget = {};
                        target[key] = newTarget;
                    }
                    target = newTarget;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            // We now have the category object, so now we just need the last value to find the key to the array of filter objects
            if (Array.isArray(target[last.key])) {
                target[last.key].push(selected.value);
            } else {
                target[last.key] = [
                    selected.value
                ];
            }
            var ref;
            var newChip1 = {
                name: selected.name,
                highlighted: (ref = selectionChain.map(function(s) {
                    return s.name;
                }).reduce(function(total, element) {
                    return total === null ? element : "".concat(total, ":").concat(element);
                }, null)) !== null && ref !== void 0 ? ref : "",
                removeAssociatedFilter: function() {
                    var values = target[last.key];
                    if (!Array.isArray(values)) {
                        return;
                    }
                    var filteredValues = values.filter(function(v) {
                        return v !== selected.value;
                    });
                    if (!filteredValues.length) {
                        delete target[last.key];
                    } else {
                        target[last.key] = filteredValues;
                    }
                },
                colors: selected.colors
            };
            setChips((0,_to_consumable_array/* default */.Z)(chips).concat([
                newChip1
            ]));
            setSelectionChain([]);
            setTextFieldInput("");
            props.onSuggestions((0,_object_spread/* default */.Z)({}, selectedOptions.current));
        }
    };
    var handleOnInputEnter = function(event) {
        // Was this enter to select an option
        if (selectedSuggestion !== null) {
            didSelectSuggestion(selectedSuggestion);
            event.preventDefault();
        }
    };
    var handleDeleteChip = function(chip, index) {
        chips.splice(index, 1);
        var newChips = (0,_to_consumable_array/* default */.Z)(chips);
        setChips(newChips);
        chip.removeAssociatedFilter();
        props.onSuggestions((0,_object_spread/* default */.Z)({}, selectedOptions.current));
    };
    var clear = function() {
        setChips([]);
        setTextFieldInput("");
        if (props.onSuggestions) {
            currentSuggestion.current = undefined;
            selectedOptions.current = {};
            props.onSuggestions({});
        }
    };
    var scrollSuggestionIntoView = function(selected) {
        var ref;
        return (ref = suggestionRef.current[selected]) === null || ref === void 0 ? void 0 : ref.scrollIntoView(false);
    };
    var onKeyDown = function(e) {
        if (e.key === "ArrowUp") {
            if (selectedSuggestion !== null) {
                var selected = Math.max(0, selectedSuggestion - 1);
                setSelectedSuggestion(selected);
                scrollSuggestionIntoView(selected);
            }
            return;
        }
        if (e.key === "ArrowDown") {
            if (selectedSuggestion !== null) {
                var selected1 = Math.min(filteredSuggestions.length - 1, selectedSuggestion + 1);
                setSelectedSuggestion(selected1);
                scrollSuggestionIntoView(selected1);
            }
            return;
        }
        if (e.key === "Enter") {
            handleOnInputEnter(e);
            return;
        }
    // Normal text input
    };
    var onTextFieldChange = function(e) {
        // When 2 categories have been selected we do "a: b: c"
        // This simply counts the amount of :'s, since if the user has backspaced to "a: b" they probably want to change that choice
        var value = e.target.value;
        var sections = value.split(":");
        var splits = sections.length - 1;
        if (splits !== selectionChain.length) {
            setSelectionChain(selectionChain.slice(0, splits));
        }
        setTextFieldInput(value);
    };
    var focusStates = (0,react.useRef)({
        inputHover: false,
        inputEditing: false,
        suggestionHover: false
    });
    var chipDivRef = (0,react.useRef)(null);
    var suggestionDivRef = (0,react.useRef)(null);
    // We only unfocus is the mouse is outside both divs, and the input text field is unfocused
    var doFocusCheck = (0,react.useMemo)(function() {
        return function() {
            var _current = focusStates.current, inputHover = _current.inputHover, inputEditing = _current.inputEditing, suggestionHover = _current.suggestionHover;
            if (!inputHover && !inputEditing && !suggestionHover) {
                setIsFocused(false);
            }
        };
    }, [
        focusStates,
        setIsFocused
    ]);
    (0,react.useEffect)(function() {
        if (chipDivRef.current) {
            chipDivRef.current.addEventListener("mouseenter", function() {
                return focusStates.current.inputHover = true;
            });
            chipDivRef.current.addEventListener("mouseleave", function() {
                focusStates.current.inputHover = false;
                doFocusCheck();
            });
        }
        if (suggestionDivRef.current) {
            suggestionDivRef.current.addEventListener("mouseenter", function() {
                return focusStates.current.suggestionHover = true;
            });
            suggestionDivRef.current.addEventListener("mouseleave", function() {
                focusStates.current.suggestionHover = false;
                doFocusCheck();
            });
        }
    }, []);
    var ref7;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        container: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                item: true,
                xs: 11,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chip_input, {
                        allowDuplicates: false,
                        clearInputValueOnChange: false,
                        renderChip: renderChip,
                        inputValue: textFieldInput,
                        chips: chips,
                        placeholder: props.placeholderText ? props.placeholderText : t([
                            "shared:filterValues"
                        ], {
                            defaultValue: "Filter values.."
                        }),
                        onAdd: function(chip) {
                            return setChips((0,_to_consumable_array/* default */.Z)(chips).concat([
                                chip
                            ]));
                        },
                        onDelete: handleDeleteChip,
                        InputProps: {
                            onKeyDown: onKeyDown,
                            value: textFieldInput,
                            onChange: function(e) {
                                return onTextFieldChange(e);
                            },
                            onFocus: function() {
                                setIsFocused(true);
                                focusStates.current.inputEditing = true;
                            },
                            onBlur: function() {
                                focusStates.current.inputEditing = false;
                                doFocusCheck();
                            }
                        },
                        ref: function(inputRef) {
                            return chipDivRef.current = inputRef;
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            display: isFocused ? "unset" : "none"
                        },
                        ref: function(divRef) {
                            return suggestionDivRef.current = divRef;
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paper/* default */.Z, {
                            square: true,
                            className: classes.suggestionsContainerOpen,
                            children: [
                                filteredSuggestions.map(function(suggestion, index) {
                                    var ref;
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                        className: "chipInputOption",
                                        ref: function(r) {
                                            return suggestionRef.current[index] = r;
                                        },
                                        selected: selectedSuggestion === index,
                                        component: "div",
                                        onClick: function() {
                                            return didSelectSuggestion(index);
                                        },
                                        children: (ref7 = (ref = suggestion.highlight) === null || ref === void 0 ? void 0 : ref.map(function(param, index) {
                                            var isHighlighted = param.isHighlighted, text = param.text;
                                            return isHighlighted ? /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                style: {
                                                    color: theme.palette.primary.main,
                                                    fontWeight: 500
                                                },
                                                children: text
                                            }, String(index)) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                style: {
                                                    fontWeight: 500
                                                },
                                                children: text
                                            }, String(index));
                                        })) !== null && ref7 !== void 0 ? ref7 : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            style: {
                                                color: theme.palette.primary.main,
                                                fontWeight: 500
                                            },
                                            children: suggestion.name
                                        })
                                    }, index);
                                }),
                                filteredSuggestions.length === 0 && // If we have selected an option, but have none we show a message letting the user go one level up
                                (selectionChain.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                    selected: true,
                                    component: "div",
                                    className: "chipInputOption",
                                    onClick: function() {
                                        return didSelectSuggestion(Number.MAX_VALUE);
                                    },
                                    children: t("shared:noSuggestionsInCategory", {
                                        defaultValue: "There are no suggestions in this category, press enter to go back"
                                    })
                                }) : props.supportsSearch ? // If this field allows search, we show an option that creats a "search:" chip
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                                    selected: true,
                                    component: "div",
                                    className: "chipInputOption",
                                    onClick: function() {
                                        return didSelectSuggestion(Number.MAX_VALUE);
                                    },
                                    children: [
                                        t("shared:searchFor", {
                                            defaultValue: "Search for"
                                        }),
                                        ': "',
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                            children: textFieldInput
                                        }),
                                        '"'
                                    ]
                                }) : // If we've got no search, and no matches, we tell the user
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                                    selected: true,
                                    component: "div",
                                    children: [
                                        t("shared:noResults", {
                                            defaultValue: "Could not find anything for"
                                        }),
                                        ': "',
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                            children: textFieldInput
                                        }),
                                        '"'
                                    ]
                                }))
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 1,
                className: classes.discardGrid,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                    onClick: clear,
                    disabled: !textFieldInput.length && !chips.length,
                    className: classes.discardButton,
                    size: "large",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                })
            })
        ]
    });
};
/** For a chosen value, create the chip along with a function that removes this choice from the chosen options when deleted */ var selectEndChip = function(propSelections, currentlySelected, options, path, setSelected) {
    var chips = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var selectedValue = _step.value;
            var option = options.find(function(o) {
                return o.value === selectedValue;
            });
            if (!option) {
                console.error("Could not find any suggestion for", selectedValue);
                return "continue";
            }
            currentlySelected.push(option.value);
            chips.push({
                name: option.name,
                removeAssociatedFilter: function() {
                    return setSelected(currentlySelected.filter(function(v) {
                        return v !== selectedValue;
                    }));
                },
                // eslint-disable-next-line @blackbird/reduce-initial-value
                highlighted: path.length ? path.reduce(function(total, segment) {
                    return "".concat(total, ":").concat(segment);
                }) : undefined
            });
        };
        for(var _iterator = propSelections[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return chips;
};
/** Generate chips for all selected options in Category of options */ var selectChips = function(propSelections, currentlySelected, path, onChange, categories) {
    if (!categories) {
        return [];
    }
    var chips = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var _value = (0,_sliced_to_array/* default */.Z)(_step.value, 2), key = _value[0], value = _value[1];
            var type = categories.find(function(c) {
                return c.key === key;
            });
            if (!type) {
                console.error("Failed to find suggestions for category key", key);
                return "continue";
            }
            if ("values" in type) {
                var _chips;
                var ref;
                (ref = (_currentlySelected = currentlySelected)[_key = key]) !== null && ref !== void 0 ? ref : _currentlySelected[_key] = [];
                (_chips = chips).push.apply(_chips, (0,_to_consumable_array/* default */.Z)(selectEndChip(value, currentlySelected[key], type.values, (0,_to_consumable_array/* default */.Z)(path).concat([
                    type.name
                ]), function(newValue) {
                    currentlySelected[key] = newValue;
                    onChange();
                })));
            } else {
                var _chips1;
                if (typeof value !== "object") {
                    console.error("Got to key ".concat(key, " and expected to find object for next level of suggestion, but found"), value);
                    return "continue";
                }
                var ref1;
                (ref1 = (_currentlySelected1 = currentlySelected)[_key1 = key]) !== null && ref1 !== void 0 ? ref1 : _currentlySelected1[_key1] = {};
                (_chips1 = chips).push.apply(_chips1, (0,_to_consumable_array/* default */.Z)(selectChips(value, currentlySelected[key], (0,_to_consumable_array/* default */.Z)(path).concat([
                    type.name
                ]), onChange, type.options)));
            }
        };
        for(var _iterator = Object.entries(propSelections)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return chips;
};
/** For selected options in `propSelections` generate all the appropriate chips */ var outerChipSelect = function(propSelections, currentlySelected, suggestions, onChange, t) {
    var chips = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var _value = (0,_sliced_to_array/* default */.Z)(_step.value, 2), key = _value[0], value = _value[1];
            var type = suggestions.find(function(c) {
                return c.key === key;
            });
            if (!type) {
                // An outer key called "search" does not require a suggestion to make a chip
                if (key === "search" && Array.isArray(value)) {
                    var castedSelected = currentlySelected;
                    var currentList = castedSelected.search;
                    if (!currentList) {
                        currentList = [];
                        castedSelected.search = currentList;
                    }
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        var _loop = function() {
                            var keyword = _step1.value;
                            currentList.push(keyword);
                            chips.push({
                                name: keyword,
                                highlighted: t("shared:search", {
                                    defaultValue: "Search"
                                }),
                                removeAssociatedFilter: function() {
                                    var ref;
                                    castedSelected.search = (ref = castedSelected.search) === null || ref === void 0 ? void 0 : ref.filter(function(k) {
                                        return k !== keyword;
                                    });
                                }
                            });
                        };
                        for(var _iterator = value[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                } else {
                    console.error("Failed to find suggestions for category key", key);
                }
                return "continue";
            }
            // @ts-ignore
            if (typeof type === "object" && "values" in type) {
                var _chips;
                var ref;
                (ref = (_currentlySelected2 = currentlySelected)[_key2 = key]) !== null && ref !== void 0 ? ref : _currentlySelected2[_key2] = [];
                (_chips = chips).push.apply(_chips, (0,_to_consumable_array/* default */.Z)(selectEndChip(value, currentlySelected[key], type.values, [
                    type.name
                ], function(newValue) {
                    currentlySelected[key] = newValue;
                    onChange();
                })));
            } else {
                var _chips1;
                var ref1;
                (ref1 = (_currentlySelected3 = currentlySelected)[_key3 = key]) !== null && ref1 !== void 0 ? ref1 : _currentlySelected3[_key3] = {};
                if (typeof value !== "object" || value === null) {
                    console.error("Got to key ".concat(key, " and expected to find object for next level of suggestion, but found"), value);
                    return "continue";
                }
                (_chips1 = chips).push.apply(_chips1, (0,_to_consumable_array/* default */.Z)(selectChips(value, currentlySelected[key], [
                    type.name
                ], type.options)));
            }
        };
        for(var _iterator = Object.entries(propSelections)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return chips;
};
/** Filter out any values in `changed` that already existed in `original` */ var getNewOptions = function(original, changed) {
    var allKeys = Object.keys(original).concat(Object.keys(changed));
    var out = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var key = _step.value;
            if (out[key] !== undefined) {
                // We've already set this key
                return "continue";
            }
            var originalVal = original[key];
            var changedVal = changed[key];
            // New key added, so we add it all
            if (originalVal === undefined && changedVal !== undefined) {
                out[key] = changedVal;
                return "continue";
            }
            // This key was removed, so we remove it
            if (originalVal !== undefined && changedVal === undefined) {
                return "continue";
            }
            if (Array.isArray(originalVal) && Array.isArray(changedVal)) {
                var newValues = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    var _loop = function() {
                        var val = _step1.value;
                        if (originalVal.some(function(existing) {
                            return lodash_default().isEqual(val, existing);
                        })) {
                            // We already have this value
                            return "continue";
                        }
                        newValues.push(val);
                    };
                    for(var _iterator = changedVal[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                // If we're here we know that T[keyof T] is not an object, but TS does not know, so we need a lil cast
                out[key] = newValues;
                return "continue";
            }
            var castedOriginal = originalVal;
            var castedChanged = changedVal;
            // Same as above, TS does not realize that here T[keyof T] must be an object so we can just set it
            out[key] = getNewOptions(castedOriginal, castedChanged);
        };
        for(var _iterator = allKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return out;
};
/* harmony default export */ var autosuggest_chip_input = (AutosuggestChipInput);

;// CONCATENATED MODULE: ./components/chip-filter/autosuggest-card-header.tsx










var autosuggest_card_header_useStyles = (0,mui/* makeStyles */.ZL)()(function(theme) {
    return {
        action: {
            marginTop: 0,
            alignSelf: "normal",
            display: "flex",
            alignItems: "center",
            marginLeft: theme.spacing()
        },
        avatar: {
            "@media print": {
                display: "none"
            }
        }
    };
});
var AutosuggestCardHeader = function(_param) {
    var action = _param.action, inputProps = (0,_object_without_properties/* default */.Z)(_param, [
        "action"
    ]);
    var theme = (0,useTheme/* default */.Z)();
    var classes = autosuggest_card_header_useStyles().classes;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader/* default */.Z, {
                classes: {
                    action: classes.action,
                    avatar: classes.avatar
                },
                action: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: action
                }),
                avatar: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                    sx: {
                        backgroundColor: theme.palette.primary.main
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {})
                }),
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(autosuggest_chip_input, (0,_object_spread/* default */.Z)({}, inputProps))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var autosuggest_card_header = (AutosuggestCardHeader);


/***/ })

}]);